<template>
  <div class="authentication-background">
    <div v-if="isBusiness">
      <img
        v-if="companyLogo"
        class="authentication-background__logo"
        :src="companyLogo"
        :alt="companyName"
      />
      <DefaultBusinessPic
        v-else
        class="authentication-background__logo authentication-background__logo--svg"
      />
    </div>
    <div v-else>
      <img
        class="ine-form__logo"
        src="@/assets/images/home-logo.png"
        alt="INE logo"
      />
      <AdditionalLinks class="authentication-background__additional-links" />
    </div>
  </div>
</template>

<script>
import DefaultBusinessPic from '@/assets/images/business/default-company-account.svg'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'

export default {
  name: 'AuthenticationBackground',
  components: {
    AdditionalLinks,
    DefaultBusinessPic: { ...DefaultBusinessPic, name: 'DefaultBusinessPic' },
  },
  props: {
    companyLogo: {
      type: String,
      required: false,
    },
    companyName: {
      type: String,
      required: false,
    },
    isBusiness: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.authentication-background {
  position: relative;
  background-image: url(~@/assets/images/backgrounds/businessinvitation-bg.png);
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 137px;
  height: 137px;
  @include mobile {
    min-height: 180px;
    height: 180px;
  }
  @include tablet {
    width: 50%;
    min-height: 100vh;
    height: 100vh;
  }
  &__logo {
    position: absolute;
    z-index: 99;
    bottom: 0;
    left: 50%;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    overflow: hidden;
    &--svg {
      width: 150px;
      height: 150px;
    }
    transform: translate(-50%, 50%);
    @include tablet {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__additional-links {
    display: none;
    @include tablet {
      display: block;
    }
  }
}
.navbar-app {
  display: none;
}
</style>
